import React, { useState } from 'react';

import { Button } from 'react-bootstrap';

export default function CopyButton({content}) {

  const [copied, setCopied] = useState(0);

  return(
    <Button 
      variant={!copied ? "success" : "outline-success"}
      onClick={() => {
        
        function listener(e) {
          e.clipboardData.setData("text/html", content);
          e.preventDefault();
        }

        document.addEventListener("copy", listener);
        document.execCommand("copy");
        document.removeEventListener("copy", listener);
        
        setCopied(1);
        setTimeout(() => {
          setCopied(0);
        }, 2000);

      }}
    >{!copied ? "Copy to clipboard" : "✔ Copied"}</Button>
  );
};